import "./display-card-subtitle.scss";

interface IDisplayCardSubtitleProps
{
    /** Szabad helyek (kategóriától függetlenül) */
    freeParkingSpace: number;

    /** Összes létező hely a zónában */
    allParkingSpace: number;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function DisplayCardSubtitle(props: IDisplayCardSubtitleProps)
{
    return (<div className="display-card-subtitle">{_renderSubtitleText(props.freeParkingSpace, props.allParkingSpace)}</div>);
}

/**
 * Összeállítja az alcímet a szabad és az elérhető helyek használatával.
 * @param freeParkingSpace
 * @param allParkingSpace
 */
function _renderSubtitleText(freeParkingSpace: number, allParkingSpace: number)
{
    return (freeParkingSpace + " / " + allParkingSpace + " szabad hely");
}
